import { GridRow } from './domain';
import { FilterPartialExpression } from './filter';
import { CompleteReason, DealType } from './graphql-grid';
import { SortDirection, SortParams } from './grid';

export enum DealsScreenUrlSearchParam {
    sortKey = 'sort-key',
    sortDirection = 'sort-direction',
    ulogin = 'ulogin',
    filter = 'filter',
    noStats = 'no-stats'
}

export interface DealsSourceParams {
    sortParams?: SortParams;
    login: string;
    filter?: FilterPartialExpression[];
    noStats?: string;
}

export interface InfoByCid {
    [cid: string]: {
        name: string;
        client: string;
    };
}

export interface DealsScreenUrlParams {
    sortKey?: string | null;
    sortDirection?: SortDirection | null;
    ulogin?: string | null;
    filter?: string | null;
    noStats?: string | null;
}

export interface DealsData {
    data: Array<Deal>;
    allItemsIds: Array<string>;
    total: number;
}

export interface Deal extends GridRow {
    clicks?: number;
    completeReason?: CompleteReason;
    contacts?: string;
    cpc?: number;
    cpm?: number;
    ctr?: number;
    currencyCode?: string;
    dateEnd?: string;
    dateStart?: string;
    dealType: DealType;
    description?: string;
    expectedImpressionsPerWeek?: number;
    expectedMoneyPerWeek?: number;
    agencyFeePercent?: number;
    minPrice?: number;
    name: string;
    numberOfLinkedCampaigns: number;
    placements: {
        domain: string;
        formats: string[];
    }[];
    publisherName: string;
    shows?: number;
    spent?: number;
    status: dealStatus;
    targetingsText: string;
}

export interface DealDetailJavaItem {
    id: string;
    agency_fee_percent: number;
    clicks?: number;
    client_id: number;
    complete_reason: CompleteReason;
    contacts: string;
    cpc?: number;
    cpm?: number;
    ctr?: number;
    currency_code: string;
    date_end?: string;
    date_start?: string;
    deal_type: DealType;
    description?: string;
    expected_impressions_per_week?: number;
    expected_money_per_week?: number;
    min_price?: number;
    name: string;
    number_of_linked_campaigns: number;
    placements: {
        domain: string;
        formats: string[];
        impId: number[];
        pageId: number;
    }[];
    publisher_name: string;
    shows?: number;
    spent?: number;
    status: dealStatus;
    targetings_text: string;
}

export interface DealDetailJavaCampaign {
    campaignId: number;
    campaignName: string;
    clientId: number;
    userName: string;
}

export interface DealDetailCampaign {
    campaignId: number;
    campaignName: string;
    clientId: number;
    userName: string;
}

export enum dealType {
    PREFERRED_DEAL = 'PREFERRED_DEAL',
    PRIVATE_MARKETPLACE = 'PRIVATE_MARKETPLACE'
}

export enum dealStatus {
    RECEIVED = 'RECEIVED',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    ARCHIVED = 'ARCHIVED'
}

export enum dealStatusForFilter {
    RECEIVED = 'RECEIVED',
    ACTIVE = 'ACTIVE',
    COMPLETED_BY_CLIENT = 'COMPLETED_BY_CLIENT',
    COMPLETED_BY_PUBLISHER = 'COMPLETED_BY_PUBLISHER',
    COMPLETED_BY_DATE = 'COMPLETED_BY_DATE',
    ARCHIVED = 'ARCHIVED'
}

export interface DealDetailJava {
    deal: DealDetailJavaItem;
    campaigns: DealDetailJavaCampaign[];
}

export interface DealDetail {
    deal: Deal;
    campaigns: DealDetailCampaign[];
}

export interface DealsUpdateObject {
    add_links: {
        campaign_id: number;
        deal_id: number;
    }[];
    deals: {
        deal_id: number;
        description?: string | null;
        name?: string;
    }[];
    remove_links: {
        campaign_id: number;
        deal_id: number;
    }[];
}

export type DealsCacheKeysDict = Map<string, string>;

export interface DealItemAction {
    onSettingsClick: (id: number) => void;
}
